export default {
  GET_FINANCES_USER_COURSES: 'GET_FINANCES_USER_COURSES',
  GET_FINANCES_USER_TRIAL_COURSES: 'GET_FINANCES_USER_TRIAL_COURSES',

  GET_FINANCES_USER_DOCUMENTS: 'GET_FINANCES_USER_DOCUMENTS',
  GET_FINANCES_DOCUMENTS_NAME: 'GET_FINANCES_DOCUMENTS_NAME',

  GET_FINANCES_ACCOUNTS: 'GET_FINANCES_ACCOUNTS', 
  GET_FINANCES_STUDENT_BUTTON_ACCOUNT: 'GET_FINANCES_STUDENT_BUTTON_ACCOUNT', 

  GET_PAY_ACTUAL_INVOICE: 'GET_PAY_ACTUAL_INVOICE',
  GET_PAY_ACTUAL_TARIFFS: 'GET_PAY_ACTUAL_TARIFFS',

  GET_PAYMENTS_METHODS: 'GET_PAYMENTS_METHODS',
  GET_PAYMENT_LINK: 'GET_PAYMENT_LINK',

  GET_PAY_PDF: 'GET_PAY_PDF',

  GET_PAY_DETAILS: 'GET_PAY_DETAILS', 
  
  CREATE_COPY_PAYMENT: 'CREATE_COPY_PAYMENT',

  GET_FINANCES_ERROR: 'GET_FINANCES_ERROR',
  GET_FINANCES_ERROR_404: 'GET_FINANCES_ERROR_404',

  GET_FINANCES_MESSAGE: 'GET_FINANCES_MESSAGE',

  START_FETCHING_FINANCES: 'START_FETCHING_FINANCES',
  STOP_FETCHING_FINANCES: 'STOP_FETCHING_FINANCES',

  START_FETCHING_GENERAL_BTN: 'START_FETCHING_GENERAL_BTN',
  STOP_FETCHING_GENERAL_BTN: 'STOP_FETCHING_GENERAL_BTN',

  SET_PARAM_INVOICE: 'SET_PARAM_INVOICE',
  SET_PARAM_PAYMENT_UUID: 'SET_PARAM_PAYMENT_UUID',

  SET_FULL_COURSE_TARIFF: 'SET_FULL_COURSE_TARIFF',
};